export default __webpack_public_path__ + "files/8b841a4d47a221fdb5ca260f74722e58.png";